<template>
  <v-container>
    <div class="text-center">
      <LoaderDialog
        :activeDialog="loaderCard || loaderConfirm"
        :message="loaderMessage"
        :current="autosAceitosCount"
        :total="autosAceitarTotal"
        :success="loaderSuccess"
      />
      <Transportadora />

      <v-dialog v-model="dialog" persistent :maxWidth="autosNotificar > 0 ? 1050 : 850">
        <v-card>
          <v-card-title class="mt-4 text-h5 primary white--text"> Termos de Uso </v-card-title>
          <v-card-text class="subtitle-1 mt-5">
            Para continuar utilizando os nossos serviços é necessario ler e aceitar nossos termos de
            uso.
          </v-card-text>
          <!-- <iframe
            :src="pdfTermoDeUsoDeDados"
            width="100%"
            height="800"
            style="border: none"
          ></iframe> -->
          <!-- <section v-if="autosNotificar > 0" class="pa-5">
            <v-data-table
              v-model="tableAutosANotificar.selected"
              :headers="headers"
              :items="tableAutosANotificar.items"
              :loading="tableAutosANotificar.loading"
              selectable-key
              style="border: solid 0.1px #d6dadb"
            >
              <template v-slot:item.valor="{ item }">
                <tbody>
                  <tr>
                    <td>R$ {{ item.valor | monetary }}</td>
                  </tr>
                </tbody>
              </template>
            </v-data-table>
          </section> -->
          <v-card-text class="subtitle-1 mt-5">
            <div class="mt-5">
              <div class="d-flex g-3 align-items-center">
                <v-checkbox
                  class="ma-0"
                  v-model="checkboxTermos"
                  :label="`Declaro que li e aceito os termos de`"
                  hide-details
                ></v-checkbox>
                <!-- <a
                  class="ma-0 ml-1 text-decoration-underline"
                  href="/transportes/servicos/politica-privacidade"
                  style="margin-top: 2px !important"
                >
                 termos.</a -->
                <a
                  :href="pdfTermoDeUsoDeDados"
                  :title="'Retornar a página inicial'"
                  :class="'button text-decoration-underline'"
                  target="_blank"
                  rel="noopener noreferrer"
                  style="margin-top: 2px; margin-right: 5px; margin-left: 3px !important"
                >
                  uso de dados.
                </a>
              </div>
              <!-- <v-checkbox
                v-if="autosNotificar > 0"
                v-model="checkboxAutosNotificar"
                :label="`Aceito todas as multas com a situação a notificar.`"
                class="ma-0"
                hide-details
              ></v-checkbox> -->
              <vue-recaptcha
                ref="recaptcha"
                :sitekey="siteKey"
                :loadRecaptchaScript="true"
                @verify="verifyRecaptcha"
                @expired="expiredRecaptcha"
                class="recaptcha mt-5"
              ></vue-recaptcha>
              <v-input v-model="recaptcha" :rules="[rules.required]"></v-input>
            </div>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="primary" text @click="logout()"> Cancelar </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="aceitarTermosEAutos()" :disabled="!checkboxTermos">
              Confirmar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <!-- <LoaderDialog :activeDialog="loaderCard" /> -->
    <services-list v-if="lgpb && tipoServicoCarregado" :data="listService"></services-list>
  </v-container>
</template>
<script>
import Vue from 'vue';
import ServicesList from '@/components/ServicesList.vue';
import AutoInfracaoService from '@/services/auto_infracao.service';
import TransportadoraAuthService from '@/services/transportadora.auth.service';
import newNegociationService from '@/services/financeiro/new-negociation.service';
import VueRecaptcha from 'vue-recaptcha';
import { VUE_APP_RECAPTCHA_KEY } from '@/commons/config';
import GlobalStore from '@/store/modules/global';
import {
  dateFormat,
  monetaryFormat,
  revenueStatusFormat,
  cnpjCpfFormat,
  contributorFormat,
  competenciaFormat,
} from '@/util/filters';
import { mapState } from 'vuex';
import transportadoraAuthService from '@/services/transportadora.auth.service';
// import fileLGPD from "@/assets/lgpd/TERMO-DE-CONSENTIMENTO-PARA-TRATAMENTO-DE-DADOS-PESSOAIS.pdf";
import LoaderDialog from './parcelamento/components/LoaderDialog.vue';
import Transportadora from '@/components/layout/Transportadora.vue';
import VeiculoService from '@/services/sit-pedidos/veiculo.service';

export default Vue.extend({
  name: 'Servicos',
  components: {
    ServicesList,
    VueRecaptcha,
    LoaderDialog,
    Transportadora,
  },
  data: () => {
    return {
      pdfTermoDeUsoDeDados:
        process.env.BASE_URL + 'TERMO-DE-CONSENTIMENTO-PARA-TRATAMENTO-DE-DADOS-PESSOAIS.pdf',
      pdfTermoAceiteParcelamento:
        process.env.BASE_URL + 'TERMO DE ADESÃO AO PARCELAMENTO DE DÉBITOS.pdf',
      listService: [
        {
          name: '',
          url: '/transportes/servicos',
          external: false,
          list: [
            {
              name: 'Consulta de Pendências',
              url: '/consulta-de-pendencias',
              icon: 'find_in_page',
              external: false,
            },
            {
              name: 'Certificado de Registro',
              url: '/certificado-de-registro',
              icon: 'picture_in_picture_alt',
              external: false,
            },
            {
              name: 'Extrato de Infração',
              url: '/extrato-de-infracao',
              icon: 'receipt',
              external: false,
            },
            {
              name: 'Licença Especial',
              url: '/licenca-especial',
              icon: 'beenhere',
              external: false,
            },
            {
              name: 'Notificação de Infração',
              url: '/notificacao-de-infracao',
              icon: 'notification_important',
              external: false,
            },
            {
              name: 'Renovação do Registro de Veículo',
              url: '/pedidos/renovacao-registro-veiculo',
              icon: 'assignment',
              external: false,
            },
            {
              name: 'Relatório de Frota Veículo',
              url: '/relatorio-frota-veiculo',
              icon: 'insert_chart',
              external: false,
            },
            {
              name: 'Taxas Avulsas',
              url: '/taxas-avulsas',
              icon: 'fa-barcode',
              external: false,
            },
            {
              name: 'Relatório de Frota Auto de Infração',
              url: '/relatorio-frota-auto-infracao',
              icon: 'pie_chart',
              external: false,
            },
            {
              name: 'Parcelamento',
              url: '/parcelamento',
              icon: 'fa-calculator',
              external: false,
            },
            {
              name: 'Taxas de Regulação',
              url: '/taxas-regulacao',
              icon: 'request_quote',
              external: false,
            },
            {
              name: 'Renovação Cadastro Transportadora',
              url: '/pedidos/renovacao-transportadora',
              icon: 'assignment',
              external: false,
              disabled: false,
            },
            // {
            // 	name: "Cadastro Transportadora",
            // 	url: "/cadastro-transportadora",
            // 	icon: "assignment",
            // 	external: false,
            // },
            {
              name: 'Inclusão de Veículo',
              url: '/pedidos/inclusao-veiculo',
              icon: 'assignment',
              external: false,
              disabled: false,
            },
            {
              name: 'Exclusão de Veículo',
              url: '/pedidos/exclusao-veiculo',
              icon: 'assignment',
              external: false,
              disabled: false,
            },
            {
              name: 'Certificado de Inclusão de Veículo',
              url: '/certificado-inclusao-de-veiculo',
              icon: 'picture_in_picture',
              external: false,
            },
            {
              name: 'Substituição de Cooperado',
              url: '/pedidos/substituicao-cooperado',
              icon: 'person',
              external: false,
              disabled: false,
            },
          ],
        },
      ],
      dialog: false,
      tableAutosANotificar: {
        parcelamentos: [],
        list: [],
        total: 10,
        loading: false,
        selected: [],
        revenue: {},
        items: [],
      },
      headers: [
        { text: 'AITP', value: 'numeroAitp', sortable: false },
        { text: 'Data lavratura', value: 'dataLavratura' },
        { text: 'Placa', value: 'placa' },
        { text: 'Valor', value: 'valor' },
        { text: 'Status', value: 'status' },
        { text: 'Observação', value: 'descricaoInfracao', width: '20%' },
      ],
      checkboxAutosNotificar: false,
      checkboxTermos: false,
      recaptcha: null,
      siteKey: VUE_APP_RECAPTCHA_KEY,
      rules: {
        required: value => !!value || 'Esse campo deve ser preenchido',
      },
      autosNotificar: 0,
      lgpb: transportadoraAuthService.lgpd,
      auth: transportadoraAuthService.auth,
      httpError: [400],
      loaderConfirm: false,
      loaderCard: false,
      autosAceitosCount: 0,
      autosAceitarTotal: 0,
      loaderSuccess: false,
      isFretamento: false,
      isComplementar: false,
      tipoServicoCarregado: false,
    };
  },
  filters: {
    cnpjCpf: cnpjCpfFormat,
    monetary: monetaryFormat,
    statusFilter: revenueStatusFormat,
    competencia: competenciaFormat,
  },
  methods: {
    searchAutosANotificarAtualizar() {
      const { cnpj, token, numOrdem } = this.getCurrentTransportadora();
      this.loaderCard = true;
      AutoInfracaoService.loadAutosInfracaoNotificarAtualizar(cnpj, token, numOrdem).subscribe(
        res => {
          this.autosNotificar = res.length;

          if (!this.lgpb) {
            this.dialog = true;
          }
          // this.tableAutosANotificar.items = res;
          this.loaderCard = false;
        },
        error => {
          // GlobalStore.setSnackBar({
          //   show: true,
          //   message: "Não foi possível verificar os autos",
          //   type: "error",
          // });
          if (!this.lgpb) {
            this.dialog = true;
          }
          this.loaderCard = false;
        }
      );
    },
    getCurrentTransportadora() {
      return TransportadoraAuthService.currentTransportadoraValue;
    },
    async aceitarTermosEAutos() {
      const { cnpj, token, numOrdem } = this.getCurrentTransportadora();
      const storageAuth = JSON.parse(localStorage.getItem(this.auth));
      this.loaderConfirm = true;
      if (this.autosNotificar > 0) {
        const numerosAitp = this.tableAutosANotificar.items.map(e => e.numeroAitp);
        this.autosAceitarTotal = numerosAitp.length;
        this.autosAceitosCount = 0;
        const falhas = [];

        for (const numeroAitp of numerosAitp) {
          try {
            const res = await newNegociationService
              .aceitarTermosAndAutosNotificar({
                numeroAitp: [numeroAitp],
                cnpj,
                numOrdem,
                recaptcha: this.recaptcha,
                lgpd: true,
              })
              .toPromise();

            if (this.httpError.includes(res?.statusCodeValue)) {
              falhas.push(numeroAitp);
            } else {
              this.autosAceitosCount++;
            }
          } catch (error) {
            falhas.push(numeroAitp);
          }
        }

        if (falhas.length === 0) {
          this.loaderSuccess = true;
          await this.wait(1200);
          this.loaderSuccess = false;
          this.loaderConfirm = false;

          GlobalStore.setSnackBar({
            show: true,
            message: 'Requisição realizada com sucesso!',
            type: 'success',
          });
          this.lgpb = true;
          this.dialog = false;
          localStorage.setItem(this.auth, JSON.stringify({ token: storageAuth.token, lgpd: true }));
        } else {
          this.loaderConfirm = false;

          transportadoraAuthService.logout(
            'error',
            `Erro ao aceitar o(s) auto(s). Não é possível acessar funcionalidades.`
          );
        }
      } else if (!this.lgpb) {
        newNegociationService
          .aceitarTermos({
            cnpj,
            numOrdem,
            lgpd: true,
            recaptcha: this.recaptcha,
          })
          .subscribe(
            res => {
              if (this.httpError.includes(res?.statusCodeValue)) {
                GlobalStore.setSnackBar({
                  show: true,
                  message: 'Erro: Não foi possível realizar a requisição.',
                  type: 'error',
                });
                this.loaderConfirm = false;
              } else {
                GlobalStore.setSnackBar({
                  show: true,
                  message: 'Requisição realizada com sucesso!',
                  type: 'success',
                });
                this.dialog = false;
                this.loaderConfirm = false;
                this.lgpb = true;

                localStorage.setItem(
                  this.auth,
                  JSON.stringify({ token: storageAuth.token, lgpd: true })
                );
              }
            },
            error => {
              this.expiredRecaptcha();
              this.loaderConfirm = false;
              GlobalStore.setSnackBar({
                show: true,
                message: 'Não foi possível processar a requisição',
                type: 'error',
              });
            }
          );
      }
    },
    wait(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    verifyRecaptcha(value) {
      this.recaptcha = value;
    },
    expiredRecaptcha() {
      this.$refs.recaptcha.reset();
      this.recaptcha = null;
    },
    logout() {
      this.dialog = false;
      transportadoraAuthService.logout();
    },
    getTipoServico() {
      const { id } = this.transportadora;
      VeiculoService.getTipoServicoTransportadora(id).subscribe(
        res => {
          this.isFretamento = res.some(ts => ts.descricao == 'Fretamento');
          this.isComplementar = res.some(ts => ts.descricao == 'Complementar');
          this.updateListServiceDisabled();
          this.tipoServicoCarregado = true;
        },
        err => {
          this.isFretamento = false;
          this.isComplementar = false;
          this.updateListServiceDisabled();
          this.tipoServicoCarregado = true;
          console.error('Erro ao buscar tipo de serviço:', err);
        }
      );
    },
    updateListServiceDisabled() {
      const items = this.listService[0].list;
      const renovanoCadastroIndex = items.findIndex(
        item => item.name === 'Renovação Cadastro Transportadora'
      );
      const inclusalIndex = items.findIndex(item => item.name === 'Inclusão de Veículo');
      const exclusaoIndex = items.findIndex(item => item.name === 'Exclusão de Veículo');
      const substituicaoIndex = items.findIndex(item => item.name === 'Substituição de Cooperado');

      if (renovanoCadastroIndex !== -1) {
        items[renovanoCadastroIndex].disabled = !this.isFretamento;
      }
      if (inclusalIndex !== -1) {
        items[inclusalIndex].disabled = !this.isFretamento;
      }
      if (exclusaoIndex !== -1) {
        items[exclusaoIndex].disabled = !this.isFretamento;
      }
      if (substituicaoIndex !== -1) {
        items[substituicaoIndex].disabled = !this.isComplementar;
      }
    },
  },
  computed: {
    ...mapState('transportadora', ['transportadora']),
    loaderMessage() {
      if (this.loaderSuccess) {
        return 'Requisição Realizada com sucesso';
      }
      if (this.loaderConfirm && this.autosAceitarTotal > 0) {
        return 'Enviando aceites';
      }
      return undefined;
    },
  },
  mounted() {
    this.searchAutosANotificarAtualizar();
    this.getTipoServico();
  },
});
</script>
